import ModalWrapper from '@components/ModalWrapper.vue'
import SnackbarWrapper from '@components/SnackbarWrapper.vue'
import { Overlay } from '@/types'
import Vue, { CreateElement } from 'vue'
import i18n from '@/i18n'

const showModal: Overlay.ShowModal = (content, modalProps) => {
  return new Promise(
    resolve => {
      const getScopedSlots = (
        h: CreateElement
      ) => {
        if ((content as Overlay.ShowModalContent).component) {
          const { events = [], component, props } = content as Overlay.ShowModalContent
          return {
            scopedSlots: {
              default: (
                scope: Overlay.ModalScope
              ) => h(
                component,
                {
                  props,
                  on: events.reduce(
                    (
                      acc: any,
                      event: string
                    ) => ({
                      ...acc,
                      [event]: scope.actionHandler(event)
                    }),
                    {} as Record<string, any>
                  )
                }
              )
            }
          }
        }
        return {}
      }
      const Modal = Vue.extend({
        render: h => h(ModalWrapper, {
          props: {
            resolve,
            ...modalProps,
            ...(
              typeof content === 'string'
                ? { message: content }
                : {}
            )
          },
          ...getScopedSlots(h)
        }),
        i18n
      })
      const instance = new Modal()
      const el = document.createElement('div')
      document.body.appendChild(el)
      instance.$mount(el)
    }
  )
}

const showSnackbar: Overlay.ShowSnackbar = (message, snackbarProps) => {
  return new Promise(
    resolve => {
      const Snackbar = Vue.extend({
        render: h => h(SnackbarWrapper, {
          props: {
            resolve,
            message,
            ...snackbarProps
          }
        }),
        i18n
      })
      const instance = new Snackbar()
      const el = document.createElement('div')
      document.body.appendChild(el)
      instance.$mount(el)
    }
  )
}

export default Vue.extend({
  methods: {
    showSnackbar,
    showModal
  }
})
